"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UploadOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M10.71 9.71L15 5.41V23a1 1 0 002 0V5.41l4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42l-6-6a1 1 0 00-.33-.21 1 1 0 00-.76 0 1 1 0 00-.33.21l-6 6a1 1 0 001.42 1.42z"/><path d="M29 22a1 1 0 00-1 1v5H4v-5a1 1 0 00-2 0v5.5A1.5 1.5 0 003.5 30h25a1.5 1.5 0 001.5-1.5V23a1 1 0 00-1-1z"/>';
var UploadOutlineSVG = function UploadOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.UploadOutlineSVG = UploadOutlineSVG;
UploadOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UploadOutlineSVG);
exports.default = _default;